
import { Component, Prop, Vue, Watch } from '~/utility/pu-class-decorator'
import { httpHeadersCache } from '~/apps/search/helpers'
import { isSearchUrlRoute } from '~/apps/search/isSearchUrlComponent'
import { ensureArray } from '~/utility/array'
import CATEGORY_MAP from '../../json/catRoot.json'

@Component({
  httpHeaders: (ctx) => httpHeadersCache(ctx),
  middleware: ['httpHeaders', 'addParamsNoIndexTag'],
  watchQuery: false,
  key: 'SearchPage',
  validate({ route }) {
    return isSearchUrlRoute(route)
  },
})
export default class CategorySearch extends Vue {
  get lang() {
    return this.$route.params.lang || 'en-gb'
  }

  @Prop()
    slug: string

  @Watch('category', { immediate: true })
  onCategoryChange() {
    this.$nextTick(() => {
      this.$convertCom.setValues({
        pageType: 'search',
        categoryId: this.category.categoryId,
        categoryName: this.category.rootSlug,
      })
      this.$gtm.push({
        pageCategories: this.category.rootSlug,
      })
    })
  }

  get placename() {
    return ensureArray(this.$route.query.placename)[0] || undefined
  }

  get category() {
    const categoryId = findCategoryIdBySlug(this.slug)
    return {
      categoryId: categoryId,
      rootSlug: this.slug,
    }
  }
}

function findCategoryIdBySlug(slug: string): string | undefined {
  for (const [key, value] of Object.entries(CATEGORY_MAP)) {
    if (value === slug) {
      return key
    }
  }
  return undefined
}
